<template>
  <a v-if="href" :href="href" :target="target" :class="classes" v-bind="$attrs">
    <component v-if="iconComponent && !loading" :is="iconComponent" :size="iconSize" :stroke-width="2.2" class="shrink-0" />
    <span v-if="loading" class="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"></span>
    <slot>{{ loading ? loadingText : label }}</slot>
  </a>
  <router-link v-else-if="to" :to="to" :class="classes" v-bind="$attrs">
    <component v-if="iconComponent && !loading" :is="iconComponent" :size="iconSize" :stroke-width="2.2" class="shrink-0" />
    <span v-if="loading" class="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"></span>
    <slot />
  </router-link>
  <button v-else :type="type" :disabled="disabled || loading" :class="classes" v-bind="$attrs">
    <component v-if="iconComponent && !loading" :is="iconComponent" :size="iconSize" :stroke-width="2.2" class="shrink-0" />
    <span v-if="loading" class="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"></span>
    <slot>{{ loading ? loadingText : label }}</slot>
  </button>
</template>

<script lang="ts">
import { computed } from "vue";
import {
  ArrowLeft,
  Ban,
  Check,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  Download,
  Edit3,
  Eye,
  FileDown,
  History,
  LogIn,
  LogOut,
  Menu,
  Plus,
  RefreshCw,
  Save,
  Search,
  Send,
  Trash2,
  UserPlus,
  Wrench,
  X,
} from "lucide-vue-next";

const icons: Record<string, unknown> = {
  add: Plus,
  back: ArrowLeft,
  cancel: X,
  check: Check,
  close: X,
  confirm: Check,
  delete: Trash2,
  download: Download,
  edit: Edit3,
  export: FileDown,
  history: History,
  login: LogIn,
  logout: LogOut,
  menu: Menu,
  next: ChevronRight,
  prev: ChevronLeft,
  refresh: RefreshCw,
  reject: Ban,
  repair: Wrench,
  save: Save,
  search: Search,
  send: Send,
  transfer: ClipboardCheck,
  view: Eye,
  userAdd: UserPlus,
};

export default {
  inheritAttrs: false,
  props: {
    variant: { type: String, default: "primary" },
    type: { type: String, default: "button" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: "Đang xử lý..." },
    label: { type: String, default: "" },
    href: { type: String, default: "" },
    icon: { type: String, default: "" },
    target: { type: String, default: undefined },
    to: { type: [String, Object], default: null },
    size: { type: String, default: "md" },
    block: { type: Boolean, default: false },
  },
  setup(props: any) {
    const variantClass: Record<string, string> = {
      primary: "btn-primary",
      secondary: "btn-secondary",
      danger: "btn-danger",
      ghost: "btn-ghost",
      white: "btn bg-white text-brand-700 hover:bg-blue-50",
    };
    const sizeClass: Record<string, string> = {
      sm: "h-7 px-2.5",
      md: "",
      lg: "h-10 px-4",
      icon: "h-8 w-8 px-0",
    };
    const classes = computed(() => [
      variantClass[props.variant] || variantClass.primary,
      sizeClass[props.size] || "",
      props.block ? "w-full" : "",
    ]);
    const iconComponent = computed(() => icons[props.icon] || null);
    const iconSize = computed(() => (props.size === "sm" ? 14 : 16));
    return { classes, iconComponent, iconSize };
  },
};
</script>
